import { useCallback, useMemo } from 'react';

import { usePostMessage } from 'src/contexts/message';

export function useScrollToTop() {
    const message = usePostMessage();

    const isIframe = useMemo(() => {
        try {
            return window.self !== window.top;
        } catch {
            return true;
        }
    }, []);

    return useCallback(() => {
        if (isIframe) {
            message({ message: 'myhealth-booking-ui-scroll' });
        } else {
            document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [isIframe, message]);
}
